import { render, staticRenderFns } from "./singleIdeaSettingModal.vue?vue&type=template&id=76dde1f4&scoped=true"
import script from "./singleIdeaSettingModal.vue?vue&type=script&lang=js"
export * from "./singleIdeaSettingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dde1f4",
  null
  
)

export default component.exports